import React from 'preact/compat';
import { ComponentChildren } from 'preact';
import { useFormikContext } from 'formik';
import { isSelfServiceEnquiry, SelfServiceFormValues } from '../../../lib/enquiry';
import { useSelfServiceFormContext } from './context';

export default function ContactFields({ children }: ContactFieldsProps) {
    const {
        values: { enquiryType },
    } = useFormikContext<SelfServiceFormValues>();
    const {
        classNames: {
            heading: headingClassName,
        },
    } = useSelfServiceFormContext();

    if ('' === enquiryType || isSelfServiceEnquiry(enquiryType)) {
        return null;
    }

    return (
        <div id='contact-fields' role='group' aria-labelledby='contact-fields-heading' className='form__section'>
            <div className='form__header'>
                <h2 id='contact-fields-heading' className={headingClassName}>
                    Contact details
                </h2>
            </div>
            {children}
        </div>
    );
}

type ContactFieldsProps = {
    children: ComponentChildren,
};
